import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../../helpers/api';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import notifications from '../../../../../redux/notifications/actions';
import { keyByProperty } from '../../../../../helpers/core';
import { t } from '../../../../../i18n';

const api = new Api('applicants/:id/accreditations');

function* loadData({ payload }) {
  try {
    const { id, applicantAccreditationId } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { id: [id, applicantAccreditationId] },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { data } = result.data.success;

      let document_image_url = null;

      if (data.document_image_url) {
        const image = yield call(
          sendRequest,
          new Api(data.document_image_url).loadImage,
          {},
          notifications.REQUEST_ERROR,
        );

        if (image) {
          if (image.data) {
            document_image_url = image.data.fileBlobUrl;
          }
        }
      }

      const dataToSave = document_image_url ? { ...data, document_image_url } : data;

      yield put(actions.loadDataSuccess({ data: dataToSave }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadFormData({ payload }) {
  try {
    const { id } = payload;

    const result = yield call(sendRequest, api.loadFormData, { id }, notifications.REQUEST_ERROR);

    if (result && result.data && result.data.success && result.data.success.data) {
      yield put(actions.loadFormData({ data: result.data.success.data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* updateAccreditation(data) {
  try {
    const { payload } = data;
    const { editForm, id, applicantAccreditationId } = payload;
    const propsArray = Object.values(editForm);

    const accreditation_submission = keyByProperty(propsArray, 'name', prop => prop.value);

    const {
      accreditation,
      document_image,
      document_image_url: _document_image_url,
      ...otherProps
    } = accreditation_submission;

    const objToSend = { ...otherProps, accreditation_id: accreditation };

    if (document_image) {
      Object.assign(objToSend, { document_image });
    }

    const result = yield call(
      sendRequest,
      api.updateItem,
      { data: { accreditation_submission: objToSend }, id: [id, applicantAccreditationId] },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      if (result.data) {
        yield put(actions.saveSuccess({ data: accreditation_submission }));

        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.updated_successfully', {
              item: t('dash.applicants.accreditation_label'),
            }),
          }),
        );
      } else {
        yield put(actions.saveError({ data: result }));
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* addAccreditation(data) {
  try {
    const { payload } = data;
    const { editForm, id } = payload;
    const propsArray = Object.values(editForm);

    const accreditation_submission = keyByProperty(propsArray, 'name', prop => prop.value);

    const { accreditation, ...otherProps } = accreditation_submission;

    const result = yield call(
      sendRequest,
      api.createItem,
      { data: { accreditation_submission: { ...otherProps, accreditation_id: accreditation } }, id },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      if (result.data) {
        yield put(actions.addSuccess({ data: accreditation_submission }));

        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.added_successfully', {
              item: t('dash.applicants.accreditation_label'),
            }),
          }),
        );
      } else {
        yield put(actions.saveError({ data: result }));
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD, loadData),
    takeEvery(actions.LOAD, loadFormData),
    takeEvery(actions.CREATE, loadFormData),
    takeEvery(actions.SAVE, updateAccreditation),
    takeEvery(actions.ADD, addAccreditation),
  ]);
}
